export default __webpack_public_path__ + "53880312ccd4eeddbcde3ffa4dd0b947.png";